import React from "react";
import "./OdersDetail.scss";
import Header from "../../Home/HomeMain/Header/Header";

const OdersDetail = () => {
  return (
    <div className="order_deatils_main">
      <div className="order_top_detail">
        <p className="order_top_deatil">Order #23BA23</p>
        <p className="order_top_deatil">12 Apr 2024</p>
      </div>
      <div className="order_detail_second_main">
        <div className="order_deatil_div">
          <div style={{ display: "flex" }}>
            <img
              src="https://giftolexia.com/wp-content/uploads/2015/11/dummy-profile.png"
              className="order_Deatil_img"
              alt="Profile"
            />
          </div>
          <div className="order_sub_deatil_main">
            <p className="Orders_Name">Mohan Sharma</p>
            <p className="Orders_Compny">Optigo Apps</p>
            <p className="Orders_Phone">Phone : 9958857845</p>
          </div>
        </div>
        <div className="order_item_div">
          <p className="order_itemCount">2 Items</p>
          <p className="order_item_status">Pending</p>
        </div>
      </div>
      <div className="order_top_detail">
        <p className="order_top_deatil_print">Print</p>
        <p className="order_top_deatil_Send">Send</p>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <p className="order_item_InStock">OUT OF STOCK</p>
        <p className="order_item_InStock">IN STOCK</p>
      </div>

      <div className="all_order_Deatil_main">
        {Array.from({ length: 15 }, (_, index) => (
          <div className="order_detail_second_main">
            <div className="order_deatil_div">
              <div style={{ display: "flex" }}>
                <img
                  src="https://www.candere.com/media/jewellery/images/GR00103__1.jpeg"
                  className="order_Deatil_img"
                  alt="Profile"
                />
              </div>
              <div className="order_sub_deatil_main">
                <p className="Orders_Name">GW : 10</p>
                <p className="Orders_Compny">NW : 15</p>
              </div>
            </div>
            <div className="order_item_div">
              <p className="order_itemCount">$ 66,506</p>
              <p className="order_item_InStock">IN STOCK</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OdersDetail;
